import { c as _c } from "react/compiler-runtime";
import { IcoEmail16 } from '@onefootprint/icons';
import type { UserConsent, VaultData, VerifiedPrefillContext } from '@onefootprint/request-types';
import { Button, Form, LinkButton, PageShell } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConsentFooter } from '@/idv2/components/consent-footer';
type ErrorCallback = (message: string) => void;
export type CollectPhoneProps = {
  onSubmit?: (data: VaultData, onError: ErrorCallback) => void;
  isLoading?: boolean;
  email?: string;
  defaultPhone?: string;
  onChangeEmail?: () => void;
  showLegalFooter?: boolean;
  verifiedPrefillContext?: VerifiedPrefillContext;
};
type CollectPhoneFormData = {
  phone: string;
};
export const CollectPhone = t0 => {
  const $ = _c(52);
  const {
    onSubmit,
    isLoading: t1,
    email,
    defaultPhone,
    onChangeEmail,
    showLegalFooter: t2,
    verifiedPrefillContext
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const showLegalFooter = t2 === undefined ? false : t2;
  const {
    t,
    i18n
  } = useTranslation("idv2");
  const locale = i18n.language === "es" ? "es-MX" : "en-US";
  const t3 = defaultPhone ?? "";
  let t4;
  if ($[0] !== t3) {
    t4 = {
      defaultValues: {
        phone: t3
      }
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const methods = useForm(t4);
  let t5;
  if ($[2] !== methods || $[3] !== onSubmit) {
    t5 = async data => {
      const vaultData = {
        "id.phone_number": data.phone
      };
      const onError = message => {
        methods.setError("phone", {
          message
        });
      };
      onSubmit?.(vaultData, onError);
    };
    $[2] = methods;
    $[3] = onSubmit;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleSubmit = t5;
  let requiredConsent;
  if ($[5] !== showLegalFooter || $[6] !== verifiedPrefillContext) {
    requiredConsent = [];
    if (showLegalFooter) {
      let t6;
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
          kind: "terms_and_conditions"
        };
        $[8] = t6;
      } else {
        t6 = $[8];
      }
      requiredConsent.push(t6);
    }
    if (verifiedPrefillContext?.isEnabled) {
      const t6 = verifiedPrefillContext.collectsSsn ?? false;
      let t7;
      if ($[9] !== t6) {
        t7 = {
          kind: "verified_prefill",
          collectsSsn: t6
        };
        $[9] = t6;
        $[10] = t7;
      } else {
        t7 = $[10];
      }
      requiredConsent.push(t7);
    }
    $[5] = showLegalFooter;
    $[6] = verifiedPrefillContext;
    $[7] = requiredConsent;
  } else {
    requiredConsent = $[7];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp2);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleSubmit || $[16] !== methods) {
    t8 = methods.handleSubmit(handleSubmit);
    $[15] = handleSubmit;
    $[16] = methods;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== email || $[19] !== onChangeEmail || $[20] !== t) {
    t9 = email && <div className="flex items-center justify-between w-full bg-secondary rounded-sm px-4 py-3" data-dd-privacy="mask"><div className="flex items-center gap-2 min-w-0"><IcoEmail16 className="shrink-0 text-secondary" color="primary" /><span className="text-body-2 text-primary truncate">{email}</span></div><LinkButton onClick={onChangeEmail} className="shrink-0 ml-2">{t(_temp3)}</LinkButton></div>;
    $[18] = email;
    $[19] = onChangeEmail;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t(_temp4);
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t(_temp5);
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = {
      required: t11
    };
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== locale || $[29] !== t10 || $[30] !== t12) {
    t13 = <div className="w-full"><Form.Tel label={t10} name="phone" locale={locale} rules={t12} /></div>;
    $[28] = locale;
    $[29] = t10;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t) {
    t14 = t(_temp6);
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== isLoading || $[35] !== t14) {
    t15 = <Button type="submit" variant="primary" fullWidth={true} size="large" loading={isLoading}>{t14}</Button>;
    $[34] = isLoading;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t13 || $[38] !== t15 || $[39] !== t8 || $[40] !== t9) {
    t16 = <form onSubmit={t8} className="flex flex-col gap-4 items-start w-full">{t9}{t13}{t15}</form>;
    $[37] = t13;
    $[38] = t15;
    $[39] = t8;
    $[40] = t9;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== methods || $[43] !== t16) {
    t17 = <FormProvider {...methods}>{t16}</FormProvider>;
    $[42] = methods;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== requiredConsent) {
    t18 = <ConsentFooter requiredConsent={requiredConsent} />;
    $[45] = requiredConsent;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t17 || $[48] !== t18 || $[49] !== t6 || $[50] !== t7) {
    t19 = <PageShell title={t6} subtitle={t7}>{t17}{t18}</PageShell>;
    $[47] = t17;
    $[48] = t18;
    $[49] = t6;
    $[50] = t7;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  return t19;
};
export default CollectPhone;
function _temp($) {
  return $.identify.phone.title;
}
function _temp2($_0) {
  return $_0.identify.phone.subtitle;
}
function _temp3($_1) {
  return $_1.identify.phone.change;
}
function _temp4($_2) {
  return $_2.identify.phone.label;
}
function _temp5($_3) {
  return $_3.identify.phone.requiredError;
}
function _temp6($_4) {
  return $_4.identify.phone.continue;
}